export const createFocusVisibleState = (styles: { string: string }) => ({
  '&:focus-visible, &.Mui-focusVisible': styles,
})
